import React, { Component, Fragment } from 'react';
import { Card, BreadCrumb, Modal, Confirm } from '../../components';
import { Translate } from '../../contexts/Language';
import DataTable from 'react-data-table-component'
import { DataTableColumns } from '../../config/DataTableColumns';
import { Service } from '../../services';
import { Config } from '../../config';
import Select from 'react-select';
import { ErrorMessage, Validator, VRules, VConditions } from '../../components/Validator';


export class WhiteList extends Component {
    constructor(props) {
        super(props)

        this.state = {
            dataTable: {
                columns: DataTableColumns.transferOptionsWhiteList,
                rows: []
            },
            formData: {
                transferOption: "",
                country: "",
                transferType: ""

            },
            modal: false,
            modalTitle:"",
            validation: {
                error: false,
                message: ""
            }
        }

        this.onDelete = this.onDelete.bind(this);
        this.onEdit = this.onEdit.bind(this);

        this.countryOptions = [];
        this.transferOptions = [];

        this.typeOptions = [
            { value: 'W', label: "Withdrawal" },
            { value: 'D', label: "Deposit" },
            { value: 'B', label: "Both" }
        ];
    }
    componentDidMount() {

        this.onDataTable(true);
        this.onTransferOptionList()

    }
    onDataTable(country) {

        Config.utilities.loadingFetch();
        Service.TransferOptions.WhiteList().then(response => {
            if (response) {

                let dataTable = this.state.dataTable;

                dataTable.rows = response;

                this.setState({
                    dataTable: dataTable
                });

            }
            Config.utilities.loadingFetch();

            if (country) this.onCountryList();
        });

        //
    }

    onTransferOptionList() {

        Service.TransferOptions.TransferOptionList().then(response => {

            if (response) {

                this.transferOptions = response.map(item => ({ value: item.id, label: <span><img src={"/assets/psp-logo/" + (item.logo || "defaultlogo.svg")} alt="" width="20" className="mb-1" />&nbsp; {item.title}</span> }));
            }
        });
    }
    onCountryList() {


        Config.utilities.loadingFetch();

        Service.TransferOptions.CountryList().then(response => {

            if (response) {

                this.countryOptions = response.map(item => ({ value: item.name, label: <span className="capitalize"><img src={"https://www.countryflags.io/" + item.code + "/shiny/24.png"} alt="Flag" width="24" className="mb-1 mr-1" onError={(e) => e.target.src = '/assets/images/flags/null.png'} /> {item.name}</span> }));
            }

            Config.utilities.loadingFetch();

        });
    }

    onNew(modal) {
        this.setState({
            formData: {
                id: -1,
                transferOption: "",
                country: "",
                transferType: ""
            },
            modal: modal === false ? false : true,
            modalTitle:Translate("Add White List"),
            validation: {
                error: false,
                message: ""
            }
        });
    }
    onFormChange(value, key) {

        let formData = this.state.formData;

        formData[key] = value;

        this.setState({
            formData
        });
    }

    onSave() {

        let formData = Object.assign({}, this.state.formData);

        formData.transferOption = formData.transferOption.value || "";
        formData.transferType = formData.transferType.value || "";
        formData.country = formData.country.value || "";

        if (this.isValid(formData)) {
            Config.utilities.loadingFetch();

            Service.TransferOptions.WhiteListSave(formData).then(response => {

                if (response.error) {
                    this.setState({
                        validation: {
                            error: response.error,
                            message: response.message
                        }
                    });
                }
                else {
                    this.onNew(false);
                    this.onDataTable();
                }

                Config.utilities.loadingFetch();
            });
        }

    }

    onEdit(id) {

        Config.utilities.loadingFetch();

        this.setState(
            {
                modal: true,
                modalTitle:Translate("Edit White List"),
                validation: {
                    error: false,
                    message: ""
                }
            });

        Service.TransferOptions.WhiteListEdit(id).then(response => {

            if (response) {

                let formData = this.state.formData;

                formData.id = response.id;
                formData.transferOption = this.transferOptions.filter(item => item.value === response.transferOption)[0];
                formData.transferType = this.typeOptions.filter(item => item.value === response.transferType)[0];
                formData.country=this.countryOptions.filter(item=> item.value===response.country)[0];

                this.setState({
                    formData
                });
            }

            Config.utilities.loadingFetch();
        });

    }

    onDelete(id) {

        Confirm({
            title: "Are you sure?",
            type: { warning: true },
            description: "The item will be deleted.",
            onConfirm: () => {

                Config.utilities.loadingFetch();

                Service.TransferOptions.WhiteListDelete(id).then(response => {


                    Config.utilities.loadingFetch();

                    if (response) {
                        this.onDataTable();
                    }

                });

            },
            onCancel: () => {

            }
        });
    }

    isValid(data) {


        VRules["transferType"] = {
            Invalid: (value) => {
                return VConditions.Required(value)
            },
            Message: Translate("Please select Transfer Type!")
        }

        VRules["transferOption"] = {
            Invalid: (value) => {
                return VConditions.Required(value)
            },
            Message: Translate("Please select Transfer Option!")
        }

        VRules["countryy"] = {
            Invalid: (value) => {
                return VConditions.Required(value)
            },
            Message: Translate("Please select Country!")
        }


        let error = Validator.Valid(data, this.Refs);

        this.setState({
            validation: error
        });

        return !error.error;
    }

    render() {

        return (
            <Fragment>
                <BreadCrumb Title={Translate("White List")} Name={Translate("White List")} />
                <Card Title="Payment Service White List" Description="Customer panel payment systems user white list.">
                    <Modal Title={Translate("Edit Black List")} Show={this.state.modal} onClose={(e) => this.setState({ modal: false })}>
                        <div className="row mt-1 mb-1">
                            <p className="text-muted mb-2 ml-1 col-md-12 font-12">Role Information</p>
                            <div className="col-md-12">
                                <form className="form-horizontal" name="saveForm" ref={this.Refs}>
                                    <ErrorMessage Validation={this.state.validation} />
                                    <div className="form-group row ml-1 mr-1">
                                        <label htmlFor="transferOption" className="col-sm-4 col-form-label">Transfer Option</label>
                                        <div className="col-sm-8">
                                            <Select
                                                id="transferOption"
                                                value={this.state.formData.transferOption}
                                                onChange={(option) => this.onFormChange(option, "transferOption")}
                                                options={this.transferOptions}
                                                isMulti={false}
                                                name="transferOption"
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row ml-1 mr-1">
                                        <label htmlFor="transferOption" className="col-sm-4 col-form-label">{Translate("Country")}</label>
                                        <div className="col-md-8">
                                            <Select
                                                id="transferOption"
                                                value={this.state.formData.country}
                                                onChange={(option) => this.onFormChange(option, "country")}
                                                options={this.countryOptions}
                                                isMulti={false}
                                                name="transferOption"
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row ml-1 mr-1">
                                        <label htmlFor="transferType" className="col-sm-4 col-form-label">Transfer Type</label>
                                        <div className="col-sm-8">
                                            <Select
                                                id="transferType"
                                                value={this.state.formData.transferType}
                                                onChange={(option) => this.onFormChange(option, "transferType")}
                                                options={this.typeOptions}
                                                isMulti={false}
                                                name="transferType"
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row ml-1 mr-1">
                                        <label htmlFor="save-form" className="col-sm-4 col-form-label"></label>
                                        <div className="col-sm-8">
                                            <button type="button" className="btn btn-info float-right" onClick={(e) => this.onSave()}><i className="far fa-save mr-1"></i> Save Form</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </Modal>
                    <div className="row">
                        <div className="col-md-12">
                            <button type="button" className="btn btn-info position-absolute add-new-button tabless" onClick={(e) => this.onNew()}><i className="fas fa-plus"></i> Add New Country</button>
                            {this.state.dataTable.rows.length === 0 ? (
                                <div className="alert alert-light" role="alert">
                                    <em><strong>No record!</strong> {Translate('No records found for the filter.')} </em>
                                </div>) :
                                (<DataTable
                                    noHeader={true}
                                    columns={this.state.dataTable.columns(this.onDelete, this.onEdit)}
                                    data={this.state.dataTable.rows}
                                    defaultSortField="id"
                                    defaultSortAsc={false}
                                    pagination
                                    highlightOnHover />)}
                        </div>
                    </div>
                </Card>
            </Fragment>
        )
    }
}